import strategy from "./VariableRenderer.strategy";
import component from "./VariableRenderer";
export * from "./VariableRenderer.types";
export { VARIABLE_RENDERER_TYPE } from "./VariableRenderer.strategy";
var decorator = {
    strategy: strategy,
    component: component,
};
export default decorator;
